import { useInboxParamFormatter, type InboxParamFormatter } from "@heraion/ui";

import { exerciseCatalog } from "../logger/exercisesCache";
import { notifyMaxWritten } from "../maxes/useMaxesDataWeb";
import { useProfileUnit } from "../ThemeProfileBridge";

// Cache first: the network only when this browser has never read the catalog.
const loadCatalog = async () =>
  (await exerciseCatalog.loadCached()) ?? exerciseCatalog.fetchAndPersist();

/** What the shell hands InboxProvider for server rows (#182): how their
 *  params read (exercise names, weights in the athlete's unit), and the MAX
 *  re-read after the bell accepts one. Web twin of mobile bell/useBellInbox. */
export function useInboxFormat(): {
  formatParams: InboxParamFormatter;
  onMaxWritten: () => void;
} {
  const formatParams = useInboxParamFormatter({ unit: useProfileUnit(), loadCatalog });
  return { formatParams, onMaxWritten: notifyMaxWritten };
}
